import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import AddNewCase from '../Components/AddNewCase';

import headerPanel from '../styles/HeaderPanel.module.css';

const HeaderPanel = ({ typePanel, onAddNewCaseSuccess }) => {
    const navigate = useNavigate();

    const [headPage, isHeadPage] = React.useState(false);
    const [IsAddNewCaseModal, setIsAddNewCaseModal] = React.useState(false);
    const closeAddNewCaseModal = () => setIsAddNewCaseModal(false);

    const location = useLocation();
    React.useEffect(() => {
        if (location.pathname === '/home') {
            isHeadPage(true);
        } else {
            isHeadPage(false);
        }
    }, [location.pathname]);


    return (
        <>
            {IsAddNewCaseModal && <AddNewCase closeModal={closeAddNewCaseModal} onAddNewCaseSuccess={onAddNewCaseSuccess} />}

            {typePanel === 'Арбитражный управляющий' ?
            (
                <div className={headerPanel.panel}>
                    {headPage ?
                        (<h1>Ваш журнал</h1>)
                        :
                        (<Link to='/home' className='button'><svg viewBox="0 0 24 24"><path fill="#6563FF" d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z"></path></svg>Назад в журнал</Link>)
                    }
                    <span>
                        <a>Перейти в <svg viewBox="0 0 24 24" id="arrow-down-right"><path fill="#000000" d="M17,6a1,1,0,0,0-1,1v7.59L7.71,6.29A1,1,0,0,0,6.29,7.71L14.59,16H7a1,1,0,0,0,0,2H17a1,1,0,0,0,.38-.08,1,1,0,0,0,.54-.54A1,1,0,0,0,18,17V7A1,1,0,0,0,17,6Z"></path></svg></a>
                        <div style={{display: 'flex'}}>
                            <Link to='/applications' className='button' style={{marginRight: '4px'}}>Заявки</Link>
                            <Link to='/inbox' className='button' style={{marginRight: '4px'}}>Уведомления</Link>
                            <Link to='/favorites' className='button'>Избранное</Link>
                        </div>
                    </span>
                </div>
            )
            :
            (typePanel === 'Администратор' || typePanel === 'Менеджер' ? (
                    <div className={headerPanel.panel}>
                        {headPage ?
                            (
                                <>
                                    <button className={`button ${headerPanel.mainButton}`} onClick={() => {setIsAddNewCaseModal(true)}}>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M8 12H16M12 8V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Добавить вх. корреспонденцию
                                    </button>
                                    <a className={headerPanel.addNewCaseButtonMobile} onClick={() => {setIsAddNewCaseModal(true)}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="plus"><path fill="#6563FF" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                    </a>
                                </>
                            )
                            :
                            (
                                <Link to='/home' className='button'>
                                    <svg viewBox="0 0 24 24"><path fill="#6563FF" d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z"></path></svg>
                                    На главную
                                </Link>
                            )
                        }
                        <span>
                            <a>Перейти в <svg viewBox="0 0 24 24"><path fill="#000000" d="M17,6a1,1,0,0,0-1,1v7.59L7.71,6.29A1,1,0,0,0,6.29,7.71L14.59,16H7a1,1,0,0,0,0,2H17a1,1,0,0,0,.38-.08,1,1,0,0,0,.54-.54A1,1,0,0,0,18,17V7A1,1,0,0,0,17,6Z"></path></svg></a>
                            <div style={{display: 'flex'}}>
                                <Link to='/appointments' className='button' style={{marginRight: '4px'}}>Назначения</Link>
                                <Link to='/complaints' className='button' style={{marginRight: '4px'}}>Жалобы</Link>
                                <Link to='/other-cases' className='button'>Общие</Link>
                            </div>
                        </span>
                    </div>
                ) 
                : 
                (typePanel === 'Назначения' || typePanel === 'Жалобы' || typePanel === 'Общие' ? (
                    <div className={headerPanel.panel}>
                        {headPage ?
                            (<h1>{typePanel}</h1>)
                            :
                            (
                            <Link to='/home' className='button'>
                                <svg viewBox="0 0 24 24"><path fill="#6563FF" d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z"></path></svg>
                                Назад в журнал
                            </Link>
                            )
                        }
                        <span>
                            <a>Перейти в <svg viewBox="0 0 24 24" id="arrow-down-right"><path fill="#000000" d="M17,6a1,1,0,0,0-1,1v7.59L7.71,6.29A1,1,0,0,0,6.29,7.71L14.59,16H7a1,1,0,0,0,0,2H17a1,1,0,0,0,.38-.08,1,1,0,0,0,.54-.54A1,1,0,0,0,18,17V7A1,1,0,0,0,17,6Z"></path></svg></a>
                            <div style={{display: 'flex'}}>
                                <Link to='/inbox' className='button'>Уведомления</Link>
                            </div>
                        </span>
                    </div>
                    ) 
                    : 
                    (typePanel === 'Назад' ? (
                        <div className={headerPanel.panel}>
                            <button onClick={() => navigate(-1)} className='button'>
                                <svg viewBox="0 0 24 24"><path fill="#6563FF" d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z"></path></svg>
                                Назад
                            </button>
                            <span></span>
                        </div>
                        )
                        :
                        (
                        <>
                            <div className={headerPanel.panel}><a>Системе не удалось загрузить компонент</a></div>
                        </>
                        )
                    )
                )
            )}
        </>
    )
}

export default HeaderPanel;